import Lookup from './lookup.js';

export default class Almelakat extends Lookup
{
    
}
